import React from "react";
import PropTypes from "prop-types";

import Tooltip from "core/Tooltip";
import Flexbox from "core/Flexbox";
import { H2 } from "core/Typography";
import {
    Link,
    DisclaimerText,
    InfoIcon,
    IconButton,
    Instructions,
    InstructionsList,
    Wrapper
} from "./styles";
import AttributionText from "./AttributionText";

import { contentTypes } from "core/props";

const AttributionBasic = ({ type, title, creator }) => {
    const tooltipMessage = `Under the Basic license, you must add visible credit to the ${
        type === "photo" ? "photographer" : "artist"
    } with your use.`;

    const instructions =
        type === "photo" ? (
            <Instructions size={12}>
                Copy the attribution text below and include it in an image
                caption, credits page, or other visible location.
            </Instructions>
        ) : (
            <InstructionsList>
                <li>Embedded attribution if larger than 100px.</li>
                <li>Include in bibliography, caption, on item or tag</li>
                <li>
                    <Link
                        href="https://thenounproject.zendesk.com/hc/en-us/articles/203605383-Can-I-trademark-an-icon-to-use-for-my-business-logo-"
                        target="_blank"
                    >
                        Logo or brand use? Get special info
                    </Link>
                </li>
            </InstructionsList>
        );

    return (
        <>
            <Wrapper>
                <H2 size={16}>
                    <Flexbox alignItems="center">
                        <DisclaimerText>
                            You must add attribution
                        </DisclaimerText>
                        <Tooltip message={tooltipMessage}>
                            <IconButton>
                                <InfoIcon />
                            </IconButton>
                        </Tooltip>
                    </Flexbox>
                </H2>
                {instructions}
            </Wrapper>
            <Wrapper>
                <AttributionText>
                    {`${title} by ${creator} from NounProject.com`}
                </AttributionText>
            </Wrapper>
        </>
    );
};

AttributionBasic.propTypes = {
    type: PropTypes.oneOf(contentTypes).isRequired,
    title: PropTypes.string.isRequired,
    creator: PropTypes.string.isRequired
};

export default AttributionBasic;
